"use strict";
exports.__esModule = true;
exports.AllInstrumentTypes = exports.InstrumentType = void 0;
var InstrumentType;
(function (InstrumentType) {
    InstrumentType["opfd"] = "opfd";
    InstrumentType["cefd"] = "cefd";
    InstrumentType["etfd"] = "etfd";
    InstrumentType["uits"] = "uits";
    InstrumentType["cifd"] = "cifd";
    InstrumentType["cstk"] = "cstk";
    InstrumentType["pref"] = "pref";
    InstrumentType["oths"] = "oths";
    InstrumentType["vans"] = "vans";
    InstrumentType["opts"] = "opts";
    InstrumentType["bond"] = "bond";
    InstrumentType["mmfd"] = "mmfd";
    InstrumentType["alts"] = "alts";
    InstrumentType["cash"] = "cash";
    InstrumentType["sdba"] = "sdba";
})(InstrumentType = exports.InstrumentType || (exports.InstrumentType = {}));
exports.AllInstrumentTypes = Object.values(InstrumentType);
